import {adminHttpClient} from "../commons/adminHttpClient";


const deleteNewsTopics = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/NewsTopics/Delete`, {
        data:{id : id}
    })
}

export default deleteNewsTopics;